// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file penumbra/view/v1/view.proto (package penumbra.view.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Any, Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { Address, AddressIndex, AddressView, IdentityKey, WalletId } from "../../core/keys/v1/keys_pb.js";
import { AuctionId, DutchAuctionDescription } from "../../core/component/auction/v1/auction_pb.js";
import { BatchSwapOutputData, Position, PositionId, PositionState, Reserves, SwapPlaintext, TradingPair } from "../../core/component/dex/v1/dex_pb.js";
import { AuthorizationData, MemoPlaintext, Transaction, TransactionPerspective, TransactionPlan, TransactionView, WitnessData } from "../../core/transaction/v1/transaction_pb.js";
import { TransactionId } from "../../core/txhash/v1/txhash_pb.js";
import { IbcRelay, Ics20Withdrawal } from "../../core/component/ibc/v1/ibc_pb.js";
import { Fee, FeeTier, GasPrices } from "../../core/component/fee/v1/fee_pb.js";
import { CommitmentSource, Epoch, Nullifier } from "../../core/component/sct/v1/sct_pb.js";
import { AssetId, Denom, Metadata, Value, ValueView } from "../../core/asset/v1/asset_pb.js";
import { StateCommitment } from "../../crypto/tct/v1/tct_pb.js";
import { Amount } from "../../core/num/v1/num_pb.js";
import { Penalty, RateData } from "../../core/component/stake/v1/stake_pb.js";
import { Vote } from "../../core/component/governance/v1/governance_pb.js";
import { AppParameters } from "../../core/app/v1/app_pb.js";
import { FmdParameters, Note } from "../../core/component/shielded_pool/v1/shielded_pool_pb.js";
/**
 * Filters in an `AuctionsRequest` will be combined using `AND` logic -- that
 * is, the more filters you add, the fewer responses you're likely to get.
 *
 * @generated from message penumbra.view.v1.AuctionsRequest
 */
export class AuctionsRequest extends Message {
    /**
     * If present, filter balances to only include the account specified by the `AddressIndex`.
     *
     * @generated from field: penumbra.core.keys.v1.AddressIndex account_filter = 1;
     */
    accountFilter;
    /**
     * If present, include inactive auctions as well as active ones.
     *
     * @generated from field: bool include_inactive = 2;
     */
    includeInactive = false;
    /**
     * If set, query a fullnode for the current state of the auctions.
     *
     * @generated from field: bool query_latest_state = 3;
     */
    queryLatestState = false;
    /**
     * If present, filter to only include auctions whose IDs are in this array.
     *
     * @generated from field: repeated penumbra.core.component.auction.v1.AuctionId auction_ids_filter = 4;
     */
    auctionIdsFilter = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.AuctionsRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "account_filter", kind: "message", T: AddressIndex },
        { no: 2, name: "include_inactive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 3, name: "query_latest_state", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 4, name: "auction_ids_filter", kind: "message", T: AuctionId, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new AuctionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuctionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuctionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuctionsRequest, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.AuctionsResponse
 */
export class AuctionsResponse extends Message {
    /**
     * @generated from field: penumbra.core.component.auction.v1.AuctionId id = 1;
     */
    id;
    /**
     * The state of the returned auction.
     *
     * Only present when `query_latest_state` was provided.
     *
     * @generated from field: google.protobuf.Any auction = 2;
     */
    auction;
    /**
     * The state of any DEX positions relevant to the returned auction.
     *
     * Only present when `query_latest_state` was provided.
     * Could be empty, depending on the auction state.
     *
     * @generated from field: repeated penumbra.core.component.dex.v1.Position positions = 3;
     */
    positions = [];
    /**
     * The note recording the auction NFT.
     *
     * @generated from field: penumbra.view.v1.SpendableNoteRecord note_record = 4;
     */
    noteRecord;
    /**
     * The sequence number of the auction state _as known to the local view
     * service_. Note that the local view service may lag behind the fullnode. For
     * example, if the chain hits an auction's `end_height`, but the user hasn't
     * yet exchanged their sequence-0 (opened) auction NFT for a sequence-1
     * (closed) auction NFT, the local view service will have a sequnce number of
     * 0.
     *
     * Dutch auctions move from:
     * 0 (opened) => 1 (closed) => n (withdrawn)
     *
     * @generated from field: uint64 local_seq = 5;
     */
    localSeq = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.AuctionsResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "id", kind: "message", T: AuctionId },
        { no: 2, name: "auction", kind: "message", T: Any },
        { no: 3, name: "positions", kind: "message", T: Position, repeated: true },
        { no: 4, name: "note_record", kind: "message", T: SpendableNoteRecord },
        { no: 5, name: "local_seq", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new AuctionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuctionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuctionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuctionsResponse, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.AuthorizeAndBuildRequest
 */
export class AuthorizeAndBuildRequest extends Message {
    /**
     * The transaction plan to authorize and build.
     *
     * @generated from field: penumbra.core.transaction.v1.TransactionPlan transaction_plan = 1;
     */
    transactionPlan;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.AuthorizeAndBuildRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "transaction_plan", kind: "message", T: TransactionPlan },
    ]);
    static fromBinary(bytes, options) {
        return new AuthorizeAndBuildRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuthorizeAndBuildRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuthorizeAndBuildRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuthorizeAndBuildRequest, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.AuthorizeAndBuildResponse
 */
export class AuthorizeAndBuildResponse extends Message {
    /**
     * @generated from oneof penumbra.view.v1.AuthorizeAndBuildResponse.status
     */
    status = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.AuthorizeAndBuildResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "build_progress", kind: "message", T: AuthorizeAndBuildResponse_BuildProgress, oneof: "status" },
        { no: 2, name: "complete", kind: "message", T: AuthorizeAndBuildResponse_Complete, oneof: "status" },
    ]);
    static fromBinary(bytes, options) {
        return new AuthorizeAndBuildResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuthorizeAndBuildResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuthorizeAndBuildResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuthorizeAndBuildResponse, a, b);
    }
}
/**
 * Signals that building is in progress.
 *
 * @generated from message penumbra.view.v1.AuthorizeAndBuildResponse.BuildProgress
 */
export class AuthorizeAndBuildResponse_BuildProgress extends Message {
    /**
     * An approximate progress of the build, from 0 to 1.
     *
     * @generated from field: float progress = 1;
     */
    progress = 0;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.AuthorizeAndBuildResponse.BuildProgress";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "progress", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    ]);
    static fromBinary(bytes, options) {
        return new AuthorizeAndBuildResponse_BuildProgress().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuthorizeAndBuildResponse_BuildProgress().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuthorizeAndBuildResponse_BuildProgress().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuthorizeAndBuildResponse_BuildProgress, a, b);
    }
}
/**
 * Signals that the transaction is complete.
 *
 * @generated from message penumbra.view.v1.AuthorizeAndBuildResponse.Complete
 */
export class AuthorizeAndBuildResponse_Complete extends Message {
    /**
     * The finished transaction.
     *
     * @generated from field: penumbra.core.transaction.v1.Transaction transaction = 1;
     */
    transaction;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.AuthorizeAndBuildResponse.Complete";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "transaction", kind: "message", T: Transaction },
    ]);
    static fromBinary(bytes, options) {
        return new AuthorizeAndBuildResponse_Complete().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AuthorizeAndBuildResponse_Complete().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AuthorizeAndBuildResponse_Complete().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AuthorizeAndBuildResponse_Complete, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.BroadcastTransactionRequest
 */
export class BroadcastTransactionRequest extends Message {
    /**
     * The transaction to broadcast.
     *
     * @generated from field: penumbra.core.transaction.v1.Transaction transaction = 1;
     */
    transaction;
    /**
     * If true, wait for the view service to detect the transaction during sync.
     *
     * @generated from field: bool await_detection = 2;
     */
    awaitDetection = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.BroadcastTransactionRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "transaction", kind: "message", T: Transaction },
        { no: 2, name: "await_detection", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new BroadcastTransactionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BroadcastTransactionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BroadcastTransactionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BroadcastTransactionRequest, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.BroadcastTransactionResponse
 */
export class BroadcastTransactionResponse extends Message {
    /**
     * @generated from oneof penumbra.view.v1.BroadcastTransactionResponse.status
     */
    status = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.BroadcastTransactionResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "broadcast_success", kind: "message", T: BroadcastTransactionResponse_BroadcastSuccess, oneof: "status" },
        { no: 2, name: "confirmed", kind: "message", T: BroadcastTransactionResponse_Confirmed, oneof: "status" },
    ]);
    static fromBinary(bytes, options) {
        return new BroadcastTransactionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BroadcastTransactionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BroadcastTransactionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BroadcastTransactionResponse, a, b);
    }
}
/**
 * Signals that the transaction was broadcast successfully (but has not been confirmed).
 *
 * @generated from message penumbra.view.v1.BroadcastTransactionResponse.BroadcastSuccess
 */
export class BroadcastTransactionResponse_BroadcastSuccess extends Message {
    /**
     * The hash of the transaction that was broadcast.
     *
     * @generated from field: penumbra.core.txhash.v1.TransactionId id = 1;
     */
    id;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.BroadcastTransactionResponse.BroadcastSuccess";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "id", kind: "message", T: TransactionId },
    ]);
    static fromBinary(bytes, options) {
        return new BroadcastTransactionResponse_BroadcastSuccess().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BroadcastTransactionResponse_BroadcastSuccess().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BroadcastTransactionResponse_BroadcastSuccess().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BroadcastTransactionResponse_BroadcastSuccess, a, b);
    }
}
/**
 * Signals that the transaction has been confirmed on-chain and detected by the view server.
 *
 * Will not be sent unless await_detection was true.
 *
 * @generated from message penumbra.view.v1.BroadcastTransactionResponse.Confirmed
 */
export class BroadcastTransactionResponse_Confirmed extends Message {
    /**
     * The hash of the transaction that was broadcast.
     *
     * @generated from field: penumbra.core.txhash.v1.TransactionId id = 1;
     */
    id;
    /**
     * The height in which the transaction was detected as included in the chain, if any.
     *
     * @generated from field: uint64 detection_height = 2;
     */
    detectionHeight = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.BroadcastTransactionResponse.Confirmed";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "id", kind: "message", T: TransactionId },
        { no: 2, name: "detection_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new BroadcastTransactionResponse_Confirmed().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BroadcastTransactionResponse_Confirmed().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BroadcastTransactionResponse_Confirmed().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BroadcastTransactionResponse_Confirmed, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest
 */
export class TransactionPlannerRequest extends Message {
    /**
     * The expiry height for the requested TransactionPlan
     *
     * @generated from field: uint64 expiry_height = 1;
     */
    expiryHeight = protoInt64.zero;
    /**
     * The memo for the requested TransactionPlan.
     * The memo must be unspecified unless `outputs` is nonempty.
     *
     * @generated from field: penumbra.core.transaction.v1.MemoPlaintext memo = 3;
     */
    memo;
    /**
     * If present, only spends funds from the given account.
     *
     * @generated from field: penumbra.core.keys.v1.AddressIndex source = 4;
     */
    source;
    /**
     * Request contents
     *
     * @generated from field: repeated penumbra.view.v1.TransactionPlannerRequest.Output outputs = 20;
     */
    outputs = [];
    /**
     * @generated from field: repeated penumbra.view.v1.TransactionPlannerRequest.Spend spends = 21;
     */
    spends = [];
    /**
     * @generated from field: repeated penumbra.view.v1.TransactionPlannerRequest.Swap swaps = 30;
     */
    swaps = [];
    /**
     * @generated from field: repeated penumbra.view.v1.TransactionPlannerRequest.SwapClaim swap_claims = 31;
     */
    swapClaims = [];
    /**
     * @generated from field: repeated penumbra.view.v1.TransactionPlannerRequest.Delegate delegations = 40;
     */
    delegations = [];
    /**
     * @generated from field: repeated penumbra.view.v1.TransactionPlannerRequest.Undelegate undelegations = 50;
     */
    undelegations = [];
    /**
     * @generated from field: repeated penumbra.view.v1.TransactionPlannerRequest.UndelegateClaim undelegation_claims = 51;
     */
    undelegationClaims = [];
    /**
     * @generated from field: repeated penumbra.core.component.ibc.v1.IbcRelay ibc_relay_actions = 60;
     */
    ibcRelayActions = [];
    /**
     * @generated from field: repeated penumbra.core.component.ibc.v1.Ics20Withdrawal ics20_withdrawals = 61;
     */
    ics20Withdrawals = [];
    /**
     * @generated from field: repeated penumbra.view.v1.TransactionPlannerRequest.PositionOpen position_opens = 70;
     */
    positionOpens = [];
    /**
     * @generated from field: repeated penumbra.view.v1.TransactionPlannerRequest.PositionClose position_closes = 71;
     */
    positionCloses = [];
    /**
     * @generated from field: repeated penumbra.view.v1.TransactionPlannerRequest.PositionWithdraw position_withdraws = 72;
     */
    positionWithdraws = [];
    /**
     * @generated from field: repeated penumbra.view.v1.TransactionPlannerRequest.ActionDutchAuctionSchedule dutch_auction_schedule_actions = 73;
     */
    dutchAuctionScheduleActions = [];
    /**
     * @generated from field: repeated penumbra.view.v1.TransactionPlannerRequest.ActionDutchAuctionEnd dutch_auction_end_actions = 74;
     */
    dutchAuctionEndActions = [];
    /**
     * @generated from field: repeated penumbra.view.v1.TransactionPlannerRequest.ActionDutchAuctionWithdraw dutch_auction_withdraw_actions = 75;
     */
    dutchAuctionWithdrawActions = [];
    /**
     * @generated from field: repeated penumbra.view.v1.TransactionPlannerRequest.DelegatorVote delegator_votes = 76;
     */
    delegatorVotes = [];
    /**
     * Specifies either that the planner should compute fees automatically or that it should use a fixed fee amount.
     *
     * @generated from oneof penumbra.view.v1.TransactionPlannerRequest.fee_mode
     */
    feeMode = { case: undefined };
    /**
     * The epoch index of the transaction being planned.
     *
     * @generated from field: uint64 epoch_index = 200 [deprecated = true];
     * @deprecated
     */
    epochIndex = protoInt64.zero;
    /**
     * The epoch of the transaction being planned.
     *
     * @generated from field: penumbra.core.component.sct.v1.Epoch epoch = 201;
     */
    epoch;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.TransactionPlannerRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "expiry_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 3, name: "memo", kind: "message", T: MemoPlaintext },
        { no: 4, name: "source", kind: "message", T: AddressIndex },
        { no: 20, name: "outputs", kind: "message", T: TransactionPlannerRequest_Output, repeated: true },
        { no: 21, name: "spends", kind: "message", T: TransactionPlannerRequest_Spend, repeated: true },
        { no: 30, name: "swaps", kind: "message", T: TransactionPlannerRequest_Swap, repeated: true },
        { no: 31, name: "swap_claims", kind: "message", T: TransactionPlannerRequest_SwapClaim, repeated: true },
        { no: 40, name: "delegations", kind: "message", T: TransactionPlannerRequest_Delegate, repeated: true },
        { no: 50, name: "undelegations", kind: "message", T: TransactionPlannerRequest_Undelegate, repeated: true },
        { no: 51, name: "undelegation_claims", kind: "message", T: TransactionPlannerRequest_UndelegateClaim, repeated: true },
        { no: 60, name: "ibc_relay_actions", kind: "message", T: IbcRelay, repeated: true },
        { no: 61, name: "ics20_withdrawals", kind: "message", T: Ics20Withdrawal, repeated: true },
        { no: 70, name: "position_opens", kind: "message", T: TransactionPlannerRequest_PositionOpen, repeated: true },
        { no: 71, name: "position_closes", kind: "message", T: TransactionPlannerRequest_PositionClose, repeated: true },
        { no: 72, name: "position_withdraws", kind: "message", T: TransactionPlannerRequest_PositionWithdraw, repeated: true },
        { no: 73, name: "dutch_auction_schedule_actions", kind: "message", T: TransactionPlannerRequest_ActionDutchAuctionSchedule, repeated: true },
        { no: 74, name: "dutch_auction_end_actions", kind: "message", T: TransactionPlannerRequest_ActionDutchAuctionEnd, repeated: true },
        { no: 75, name: "dutch_auction_withdraw_actions", kind: "message", T: TransactionPlannerRequest_ActionDutchAuctionWithdraw, repeated: true },
        { no: 76, name: "delegator_votes", kind: "message", T: TransactionPlannerRequest_DelegatorVote, repeated: true },
        { no: 100, name: "auto_fee", kind: "message", T: FeeTier, oneof: "fee_mode" },
        { no: 101, name: "manual_fee", kind: "message", T: Fee, oneof: "fee_mode" },
        { no: 200, name: "epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 201, name: "epoch", kind: "message", T: Epoch },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionPlannerRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionPlannerRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionPlannerRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionPlannerRequest, a, b);
    }
}
/**
 * Request message subtypes
 *
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.Output
 */
export class TransactionPlannerRequest_Output extends Message {
    /**
     * The amount and denomination in which the Output is issued.
     *
     * @generated from field: penumbra.core.asset.v1.Value value = 1;
     */
    value;
    /**
     * The address to which Output will be sent.
     *
     * @generated from field: penumbra.core.keys.v1.Address address = 2;
     */
    address;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.TransactionPlannerRequest.Output";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "value", kind: "message", T: Value },
        { no: 2, name: "address", kind: "message", T: Address },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionPlannerRequest_Output().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionPlannerRequest_Output().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionPlannerRequest_Output().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionPlannerRequest_Output, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.Spend
 */
export class TransactionPlannerRequest_Spend extends Message {
    /**
     * The input amount and denomination in which the Spend is issued.
     *
     * @generated from field: penumbra.core.asset.v1.Value value = 1;
     */
    value;
    /**
     * The source address from which the Spend will be sent.
     *
     * @generated from field: penumbra.core.keys.v1.Address address = 2;
     */
    address;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.TransactionPlannerRequest.Spend";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "value", kind: "message", T: Value },
        { no: 2, name: "address", kind: "message", T: Address },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionPlannerRequest_Spend().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionPlannerRequest_Spend().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionPlannerRequest_Spend().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionPlannerRequest_Spend, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.Swap
 */
export class TransactionPlannerRequest_Swap extends Message {
    /**
     * The input amount and denomination to be traded in the Swap.
     *
     * @generated from field: penumbra.core.asset.v1.Value value = 1;
     */
    value;
    /**
     * The denomination to be received as a Output of the Swap.
     *
     * @generated from field: penumbra.core.asset.v1.AssetId target_asset = 2;
     */
    targetAsset;
    /**
     * The pre-paid fee to be paid for claiming the Swap outputs.
     *
     * @generated from field: penumbra.core.component.fee.v1.Fee fee = 3;
     */
    fee;
    /**
     * The address to which swap claim output will be sent.
     *
     * @generated from field: penumbra.core.keys.v1.Address claim_address = 4;
     */
    claimAddress;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.TransactionPlannerRequest.Swap";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "value", kind: "message", T: Value },
        { no: 2, name: "target_asset", kind: "message", T: AssetId },
        { no: 3, name: "fee", kind: "message", T: Fee },
        { no: 4, name: "claim_address", kind: "message", T: Address },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionPlannerRequest_Swap().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionPlannerRequest_Swap().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionPlannerRequest_Swap().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionPlannerRequest_Swap, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.SwapClaim
 */
export class TransactionPlannerRequest_SwapClaim extends Message {
    /**
     * SwapCommitment to identify the Swap to be claimed.
     * Use the commitment from the Swap message:
     * penumbra.core.component.dex.v1.Swap.body.payload.commitment.
     *
     * @generated from field: penumbra.crypto.tct.v1.StateCommitment swap_commitment = 1;
     */
    swapCommitment;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.TransactionPlannerRequest.SwapClaim";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "swap_commitment", kind: "message", T: StateCommitment },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionPlannerRequest_SwapClaim().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionPlannerRequest_SwapClaim().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionPlannerRequest_SwapClaim().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionPlannerRequest_SwapClaim, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.Delegate
 */
export class TransactionPlannerRequest_Delegate extends Message {
    /**
     * @generated from field: penumbra.core.num.v1.Amount amount = 1;
     */
    amount;
    /**
     * @generated from field: penumbra.core.component.stake.v1.RateData rate_data = 3;
     */
    rateData;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.TransactionPlannerRequest.Delegate";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "amount", kind: "message", T: Amount },
        { no: 3, name: "rate_data", kind: "message", T: RateData },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionPlannerRequest_Delegate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionPlannerRequest_Delegate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionPlannerRequest_Delegate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionPlannerRequest_Delegate, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.Undelegate
 */
export class TransactionPlannerRequest_Undelegate extends Message {
    /**
     * @generated from field: penumbra.core.asset.v1.Value value = 1;
     */
    value;
    /**
     * @generated from field: penumbra.core.component.stake.v1.RateData rate_data = 2;
     */
    rateData;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.TransactionPlannerRequest.Undelegate";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "value", kind: "message", T: Value },
        { no: 2, name: "rate_data", kind: "message", T: RateData },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionPlannerRequest_Undelegate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionPlannerRequest_Undelegate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionPlannerRequest_Undelegate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionPlannerRequest_Undelegate, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.UndelegateClaim
 */
export class TransactionPlannerRequest_UndelegateClaim extends Message {
    /**
     * The identity key of the validator to finish undelegating from.
     *
     * @generated from field: penumbra.core.keys.v1.IdentityKey validator_identity = 1;
     */
    validatorIdentity;
    /**
     * The epoch in which unbonding began, used to verify the penalty.
     *
     * @generated from field: uint64 start_epoch_index = 2 [deprecated = true];
     * @deprecated
     */
    startEpochIndex = protoInt64.zero;
    /**
     * The penalty applied to undelegation, in bps^2 (10e-8).
     * In the happy path (no slashing), this is 0.
     *
     * @generated from field: penumbra.core.component.stake.v1.Penalty penalty = 3;
     */
    penalty;
    /**
     * The amount of unbonding tokens to claim.
     * This is a bare number because its denom is determined by the preceding data.
     *
     * @generated from field: penumbra.core.num.v1.Amount unbonding_amount = 4;
     */
    unbondingAmount;
    /**
     * The height at which unbonding began.
     *
     * @generated from field: uint64 unbonding_start_height = 5;
     */
    unbondingStartHeight = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.TransactionPlannerRequest.UndelegateClaim";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "validator_identity", kind: "message", T: IdentityKey },
        { no: 2, name: "start_epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 3, name: "penalty", kind: "message", T: Penalty },
        { no: 4, name: "unbonding_amount", kind: "message", T: Amount },
        { no: 5, name: "unbonding_start_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionPlannerRequest_UndelegateClaim().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionPlannerRequest_UndelegateClaim().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionPlannerRequest_UndelegateClaim().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionPlannerRequest_UndelegateClaim, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.PositionOpen
 */
export class TransactionPlannerRequest_PositionOpen extends Message {
    /**
     * Contains the data defining the position, sufficient to compute its `PositionId`.
     *
     * Positions are immutable, so the `PositionData` (and hence the `PositionId`)
     * are unchanged over the entire lifetime of the position.
     *
     * @generated from field: penumbra.core.component.dex.v1.Position position = 1;
     */
    position;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.TransactionPlannerRequest.PositionOpen";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "position", kind: "message", T: Position },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionPlannerRequest_PositionOpen().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionPlannerRequest_PositionOpen().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionPlannerRequest_PositionOpen().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionPlannerRequest_PositionOpen, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.PositionClose
 */
export class TransactionPlannerRequest_PositionClose extends Message {
    /**
     * The position to close.
     *
     * @generated from field: penumbra.core.component.dex.v1.PositionId position_id = 1;
     */
    positionId;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.TransactionPlannerRequest.PositionClose";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "position_id", kind: "message", T: PositionId },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionPlannerRequest_PositionClose().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionPlannerRequest_PositionClose().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionPlannerRequest_PositionClose().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionPlannerRequest_PositionClose, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.PositionWithdraw
 */
export class TransactionPlannerRequest_PositionWithdraw extends Message {
    /**
     * The position to withdraw.
     *
     * @generated from field: penumbra.core.component.dex.v1.PositionId position_id = 1;
     */
    positionId;
    /**
     * The position's final reserves.
     *
     * @generated from field: penumbra.core.component.dex.v1.Reserves reserves = 2;
     */
    reserves;
    /**
     * The trading pair of the position.
     *
     * @generated from field: penumbra.core.component.dex.v1.TradingPair trading_pair = 3;
     */
    tradingPair;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.TransactionPlannerRequest.PositionWithdraw";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "position_id", kind: "message", T: PositionId },
        { no: 2, name: "reserves", kind: "message", T: Reserves },
        { no: 3, name: "trading_pair", kind: "message", T: TradingPair },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionPlannerRequest_PositionWithdraw().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionPlannerRequest_PositionWithdraw().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionPlannerRequest_PositionWithdraw().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionPlannerRequest_PositionWithdraw, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.ActionDutchAuctionSchedule
 */
export class TransactionPlannerRequest_ActionDutchAuctionSchedule extends Message {
    /**
     * The description of the auction to schedule.
     *
     * @generated from field: penumbra.core.component.auction.v1.DutchAuctionDescription description = 1;
     */
    description;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.TransactionPlannerRequest.ActionDutchAuctionSchedule";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "description", kind: "message", T: DutchAuctionDescription },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionPlannerRequest_ActionDutchAuctionSchedule().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionPlannerRequest_ActionDutchAuctionSchedule().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionPlannerRequest_ActionDutchAuctionSchedule().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionPlannerRequest_ActionDutchAuctionSchedule, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.ActionDutchAuctionEnd
 */
export class TransactionPlannerRequest_ActionDutchAuctionEnd extends Message {
    /**
     * The unique id of the auction to close.
     *
     * @generated from field: penumbra.core.component.auction.v1.AuctionId auction_id = 1;
     */
    auctionId;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.TransactionPlannerRequest.ActionDutchAuctionEnd";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "auction_id", kind: "message", T: AuctionId },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionPlannerRequest_ActionDutchAuctionEnd().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionPlannerRequest_ActionDutchAuctionEnd().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionPlannerRequest_ActionDutchAuctionEnd().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionPlannerRequest_ActionDutchAuctionEnd, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.ActionDutchAuctionWithdraw
 */
export class TransactionPlannerRequest_ActionDutchAuctionWithdraw extends Message {
    /**
     * The auction to withdraw funds from.
     *
     * @generated from field: penumbra.core.component.auction.v1.AuctionId auction_id = 1;
     */
    auctionId;
    /**
     * The sequence number of the withdrawal.
     *
     * @generated from field: uint64 seq = 2;
     */
    seq = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.TransactionPlannerRequest.ActionDutchAuctionWithdraw";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "auction_id", kind: "message", T: AuctionId },
        { no: 2, name: "seq", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionPlannerRequest_ActionDutchAuctionWithdraw().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionPlannerRequest_ActionDutchAuctionWithdraw().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionPlannerRequest_ActionDutchAuctionWithdraw().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionPlannerRequest_ActionDutchAuctionWithdraw, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.TransactionPlannerRequest.DelegatorVote
 */
export class TransactionPlannerRequest_DelegatorVote extends Message {
    /**
     * The proposal being voted on.
     *
     * @generated from field: uint64 proposal = 1;
     */
    proposal = protoInt64.zero;
    /**
     * The vote.
     *
     * @generated from field: penumbra.core.component.governance.v1.Vote vote = 2;
     */
    vote;
    /**
     * The block height at which the proposal started voting.
     *
     * @generated from field: uint64 start_block_height = 3;
     */
    startBlockHeight = protoInt64.zero;
    /**
     * The position of the state commitment tree at which the proposal is considered to have started voting.
     *
     * @generated from field: uint64 start_position = 4;
     */
    startPosition = protoInt64.zero;
    /**
     * The validators rate data for the proposal.
     *
     * @generated from field: repeated penumbra.core.component.stake.v1.RateData rate_data = 5;
     */
    rateData = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.TransactionPlannerRequest.DelegatorVote";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "proposal", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 2, name: "vote", kind: "message", T: Vote },
        { no: 3, name: "start_block_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 4, name: "start_position", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 5, name: "rate_data", kind: "message", T: RateData, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionPlannerRequest_DelegatorVote().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionPlannerRequest_DelegatorVote().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionPlannerRequest_DelegatorVote().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionPlannerRequest_DelegatorVote, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.TransactionPlannerResponse
 */
export class TransactionPlannerResponse extends Message {
    /**
     * @generated from field: penumbra.core.transaction.v1.TransactionPlan plan = 1;
     */
    plan;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.TransactionPlannerResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "plan", kind: "message", T: TransactionPlan },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionPlannerResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionPlannerResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionPlannerResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionPlannerResponse, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.AddressByIndexRequest
 */
export class AddressByIndexRequest extends Message {
    /**
     * @generated from field: penumbra.core.keys.v1.AddressIndex address_index = 1;
     */
    addressIndex;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.AddressByIndexRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "address_index", kind: "message", T: AddressIndex },
    ]);
    static fromBinary(bytes, options) {
        return new AddressByIndexRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddressByIndexRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddressByIndexRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddressByIndexRequest, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.AddressByIndexResponse
 */
export class AddressByIndexResponse extends Message {
    /**
     * @generated from field: penumbra.core.keys.v1.Address address = 1;
     */
    address;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.AddressByIndexResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "address", kind: "message", T: Address },
    ]);
    static fromBinary(bytes, options) {
        return new AddressByIndexResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddressByIndexResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddressByIndexResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddressByIndexResponse, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.WalletIdRequest
 */
export class WalletIdRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.WalletIdRequest";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new WalletIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WalletIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WalletIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WalletIdRequest, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.WalletIdResponse
 */
export class WalletIdResponse extends Message {
    /**
     * @generated from field: penumbra.core.keys.v1.WalletId wallet_id = 1;
     */
    walletId;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.WalletIdResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "wallet_id", kind: "message", T: WalletId },
    ]);
    static fromBinary(bytes, options) {
        return new WalletIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WalletIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WalletIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WalletIdResponse, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.IndexByAddressRequest
 */
export class IndexByAddressRequest extends Message {
    /**
     * @generated from field: penumbra.core.keys.v1.Address address = 1;
     */
    address;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.IndexByAddressRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "address", kind: "message", T: Address },
    ]);
    static fromBinary(bytes, options) {
        return new IndexByAddressRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IndexByAddressRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IndexByAddressRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IndexByAddressRequest, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.IndexByAddressResponse
 */
export class IndexByAddressResponse extends Message {
    /**
     * Will be absent if given an address not viewable by this viewing service
     *
     * @generated from field: penumbra.core.keys.v1.AddressIndex address_index = 1;
     */
    addressIndex;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.IndexByAddressResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "address_index", kind: "message", T: AddressIndex },
    ]);
    static fromBinary(bytes, options) {
        return new IndexByAddressResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IndexByAddressResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IndexByAddressResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IndexByAddressResponse, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.EphemeralAddressRequest
 */
export class EphemeralAddressRequest extends Message {
    /**
     * @generated from field: penumbra.core.keys.v1.AddressIndex address_index = 1;
     */
    addressIndex;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.EphemeralAddressRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "address_index", kind: "message", T: AddressIndex },
    ]);
    static fromBinary(bytes, options) {
        return new EphemeralAddressRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EphemeralAddressRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EphemeralAddressRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EphemeralAddressRequest, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.EphemeralAddressResponse
 */
export class EphemeralAddressResponse extends Message {
    /**
     * @generated from field: penumbra.core.keys.v1.Address address = 1;
     */
    address;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.EphemeralAddressResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "address", kind: "message", T: Address },
    ]);
    static fromBinary(bytes, options) {
        return new EphemeralAddressResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EphemeralAddressResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EphemeralAddressResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EphemeralAddressResponse, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.BalancesRequest
 */
export class BalancesRequest extends Message {
    /**
     * If present, filter balances to only include the account specified by the `AddressIndex`.
     *
     * @generated from field: penumbra.core.keys.v1.AddressIndex account_filter = 1;
     */
    accountFilter;
    /**
     * If present, filter balances to only include the specified asset ID.
     *
     * @generated from field: penumbra.core.asset.v1.AssetId asset_id_filter = 2;
     */
    assetIdFilter;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.BalancesRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "account_filter", kind: "message", T: AddressIndex },
        { no: 2, name: "asset_id_filter", kind: "message", T: AssetId },
    ]);
    static fromBinary(bytes, options) {
        return new BalancesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BalancesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BalancesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BalancesRequest, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.BalancesResponse
 */
export class BalancesResponse extends Message {
    /**
     * Deprecated: use `account_address` instead.
     *
     * @generated from field: penumbra.core.keys.v1.AddressIndex account = 1 [deprecated = true];
     * @deprecated
     */
    account;
    /**
     * Deprecated: use `balance_view` instead.
     *
     * @generated from field: penumbra.core.asset.v1.Value balance = 2 [deprecated = true];
     * @deprecated
     */
    balance;
    /**
     * The default address for the account.
     *
     * Note that the returned balance is for all funds sent to the account,
     * not just funds sent to its default address.
     *
     * @generated from field: penumbra.core.keys.v1.AddressView account_address = 3;
     */
    accountAddress;
    /**
     * The account's balance, with metadata.
     *
     * @generated from field: penumbra.core.asset.v1.ValueView balance_view = 4;
     */
    balanceView;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.BalancesResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "account", kind: "message", T: AddressIndex },
        { no: 2, name: "balance", kind: "message", T: Value },
        { no: 3, name: "account_address", kind: "message", T: AddressView },
        { no: 4, name: "balance_view", kind: "message", T: ValueView },
    ]);
    static fromBinary(bytes, options) {
        return new BalancesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BalancesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BalancesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BalancesResponse, a, b);
    }
}
/**
 * Requests sync status of the view service.
 *
 * @generated from message penumbra.view.v1.StatusRequest
 */
export class StatusRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.StatusRequest";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new StatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StatusRequest, a, b);
    }
}
/**
 * Returns the status of the view service and whether it is synchronized with the chain state.
 *
 * @generated from message penumbra.view.v1.StatusResponse
 */
export class StatusResponse extends Message {
    /**
     * The height the view service has synchronized to so far when doing a full linear sync
     *
     * @generated from field: uint64 full_sync_height = 1;
     */
    fullSyncHeight = protoInt64.zero;
    /**
     * The height the view service has synchronized to so far when doing a partial sync
     *
     * @generated from field: uint64 partial_sync_height = 2;
     */
    partialSyncHeight = protoInt64.zero;
    /**
     * Whether the view service is catching up with the chain state
     *
     * @generated from field: bool catching_up = 3;
     */
    catchingUp = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.StatusResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "full_sync_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 2, name: "partial_sync_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 3, name: "catching_up", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new StatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StatusResponse, a, b);
    }
}
/**
 * Requests streaming updates on the sync height until the view service is synchronized.
 *
 * @generated from message penumbra.view.v1.StatusStreamRequest
 */
export class StatusStreamRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.StatusStreamRequest";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new StatusStreamRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StatusStreamRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StatusStreamRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StatusStreamRequest, a, b);
    }
}
/**
 * A streaming sync status update
 *
 * @generated from message penumbra.view.v1.StatusStreamResponse
 */
export class StatusStreamResponse extends Message {
    /**
     * The latest known block height
     *
     * @generated from field: uint64 latest_known_block_height = 1;
     */
    latestKnownBlockHeight = protoInt64.zero;
    /**
     * The height the view service has synchronized to so far when doing a full linear sync
     *
     * @generated from field: uint64 full_sync_height = 2;
     */
    fullSyncHeight = protoInt64.zero;
    /**
     * The height the view service has synchronized to so far when doing a partial sync
     *
     * @generated from field: uint64 partial_sync_height = 3;
     */
    partialSyncHeight = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.StatusStreamResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "latest_known_block_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 2, name: "full_sync_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 3, name: "partial_sync_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new StatusStreamResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StatusStreamResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StatusStreamResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StatusStreamResponse, a, b);
    }
}
/**
 * A query for notes known by the view service.
 *
 * This message uses the fact that all proto fields are optional
 * to allow various filtering on the returned notes.
 *
 * @generated from message penumbra.view.v1.NotesRequest
 */
export class NotesRequest extends Message {
    /**
     * If set, return spent notes as well as unspent notes.
     *
     * @generated from field: bool include_spent = 2;
     */
    includeSpent = false;
    /**
     * If set, only return notes with the specified asset id.
     *
     * @generated from field: penumbra.core.asset.v1.AssetId asset_id = 3;
     */
    assetId;
    /**
     * If set, only return notes with the specified address incore.component.dex.v1.
     *
     * @generated from field: penumbra.core.keys.v1.AddressIndex address_index = 4;
     */
    addressIndex;
    /**
     * If set, stop returning notes once the total exceeds this amount.
     *
     * Ignored if `asset_id` is unset or if `include_spent` is set.
     *
     * @generated from field: penumbra.core.num.v1.Amount amount_to_spend = 6;
     */
    amountToSpend;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.NotesRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "include_spent", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 3, name: "asset_id", kind: "message", T: AssetId },
        { no: 4, name: "address_index", kind: "message", T: AddressIndex },
        { no: 6, name: "amount_to_spend", kind: "message", T: Amount },
    ]);
    static fromBinary(bytes, options) {
        return new NotesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NotesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NotesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NotesRequest, a, b);
    }
}
/**
 * A query for notes to be used for voting on a proposal.
 *
 * @generated from message penumbra.view.v1.NotesForVotingRequest
 */
export class NotesForVotingRequest extends Message {
    /**
     * The starting height of the proposal.
     *
     * @generated from field: uint64 votable_at_height = 1;
     */
    votableAtHeight = protoInt64.zero;
    /**
     * If set, only return notes with the specified asset id.
     *
     * @generated from field: penumbra.core.keys.v1.AddressIndex address_index = 3;
     */
    addressIndex;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.NotesForVotingRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "votable_at_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 3, name: "address_index", kind: "message", T: AddressIndex },
    ]);
    static fromBinary(bytes, options) {
        return new NotesForVotingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NotesForVotingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NotesForVotingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NotesForVotingRequest, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.WitnessRequest
 */
export class WitnessRequest extends Message {
    /**
     * The transaction plan to witness
     *
     * @generated from field: penumbra.core.transaction.v1.TransactionPlan transaction_plan = 3;
     */
    transactionPlan;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.WitnessRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 3, name: "transaction_plan", kind: "message", T: TransactionPlan },
    ]);
    static fromBinary(bytes, options) {
        return new WitnessRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WitnessRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WitnessRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WitnessRequest, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.WitnessResponse
 */
export class WitnessResponse extends Message {
    /**
     * @generated from field: penumbra.core.transaction.v1.WitnessData witness_data = 1;
     */
    witnessData;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.WitnessResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "witness_data", kind: "message", T: WitnessData },
    ]);
    static fromBinary(bytes, options) {
        return new WitnessResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WitnessResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WitnessResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WitnessResponse, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.WitnessAndBuildRequest
 */
export class WitnessAndBuildRequest extends Message {
    /**
     * @generated from field: penumbra.core.transaction.v1.TransactionPlan transaction_plan = 1;
     */
    transactionPlan;
    /**
     * @generated from field: penumbra.core.transaction.v1.AuthorizationData authorization_data = 2;
     */
    authorizationData;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.WitnessAndBuildRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "transaction_plan", kind: "message", T: TransactionPlan },
        { no: 2, name: "authorization_data", kind: "message", T: AuthorizationData },
    ]);
    static fromBinary(bytes, options) {
        return new WitnessAndBuildRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WitnessAndBuildRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WitnessAndBuildRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WitnessAndBuildRequest, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.WitnessAndBuildResponse
 */
export class WitnessAndBuildResponse extends Message {
    /**
     * @generated from oneof penumbra.view.v1.WitnessAndBuildResponse.status
     */
    status = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.WitnessAndBuildResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "build_progress", kind: "message", T: WitnessAndBuildResponse_BuildProgress, oneof: "status" },
        { no: 2, name: "complete", kind: "message", T: WitnessAndBuildResponse_Complete, oneof: "status" },
    ]);
    static fromBinary(bytes, options) {
        return new WitnessAndBuildResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WitnessAndBuildResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WitnessAndBuildResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WitnessAndBuildResponse, a, b);
    }
}
/**
 * Signals that building is in progress.
 *
 * @generated from message penumbra.view.v1.WitnessAndBuildResponse.BuildProgress
 */
export class WitnessAndBuildResponse_BuildProgress extends Message {
    /**
     * An approximate progress of the build, from 0 to 1.
     *
     * @generated from field: float progress = 1;
     */
    progress = 0;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.WitnessAndBuildResponse.BuildProgress";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "progress", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    ]);
    static fromBinary(bytes, options) {
        return new WitnessAndBuildResponse_BuildProgress().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WitnessAndBuildResponse_BuildProgress().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WitnessAndBuildResponse_BuildProgress().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WitnessAndBuildResponse_BuildProgress, a, b);
    }
}
/**
 * Signals that the transaction is complete.
 *
 * @generated from message penumbra.view.v1.WitnessAndBuildResponse.Complete
 */
export class WitnessAndBuildResponse_Complete extends Message {
    /**
     * The finished transaction.
     *
     * @generated from field: penumbra.core.transaction.v1.Transaction transaction = 1;
     */
    transaction;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.WitnessAndBuildResponse.Complete";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "transaction", kind: "message", T: Transaction },
    ]);
    static fromBinary(bytes, options) {
        return new WitnessAndBuildResponse_Complete().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WitnessAndBuildResponse_Complete().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WitnessAndBuildResponse_Complete().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WitnessAndBuildResponse_Complete, a, b);
    }
}
/**
 * Requests all assets known to the view service.
 *
 * @generated from message penumbra.view.v1.AssetsRequest
 */
export class AssetsRequest extends Message {
    /**
     * If set to false (default), returns all assets, regardless of whether the rest of the fields of
     * the request indicate a filter.
     *
     * @generated from field: bool filtered = 1;
     */
    filtered = false;
    /**
     * Include these specific denominations in the response.
     *
     * @generated from field: repeated penumbra.core.asset.v1.Denom include_specific_denominations = 2;
     */
    includeSpecificDenominations = [];
    /**
     * Include all delegation tokens, to any validator, in the response.
     *
     * @generated from field: bool include_delegation_tokens = 3;
     */
    includeDelegationTokens = false;
    /**
     * Include all unbonding tokens, from any validator, in the response.
     *
     * @generated from field: bool include_unbonding_tokens = 4;
     */
    includeUnbondingTokens = false;
    /**
     * Include all LP NFTs in the response.
     *
     * @generated from field: bool include_lp_nfts = 5;
     */
    includeLpNfts = false;
    /**
     * Include all proposal NFTs in the response.
     *
     * @generated from field: bool include_proposal_nfts = 6;
     */
    includeProposalNfts = false;
    /**
     * Include all voting receipt tokens in the response.
     *
     * @generated from field: bool include_voting_receipt_tokens = 7;
     */
    includeVotingReceiptTokens = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.AssetsRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "filtered", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 2, name: "include_specific_denominations", kind: "message", T: Denom, repeated: true },
        { no: 3, name: "include_delegation_tokens", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 4, name: "include_unbonding_tokens", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 5, name: "include_lp_nfts", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 6, name: "include_proposal_nfts", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 7, name: "include_voting_receipt_tokens", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new AssetsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AssetsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AssetsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AssetsRequest, a, b);
    }
}
/**
 * Requests all assets known to the view service.
 *
 * @generated from message penumbra.view.v1.AssetsResponse
 */
export class AssetsResponse extends Message {
    /**
     * @generated from field: penumbra.core.asset.v1.Metadata denom_metadata = 2;
     */
    denomMetadata;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.AssetsResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "denom_metadata", kind: "message", T: Metadata },
    ]);
    static fromBinary(bytes, options) {
        return new AssetsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AssetsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AssetsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AssetsResponse, a, b);
    }
}
/**
 * Requests the current app parameters from the view service.
 *
 * @generated from message penumbra.view.v1.AppParametersRequest
 */
export class AppParametersRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.AppParametersRequest";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new AppParametersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AppParametersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AppParametersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AppParametersRequest, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.AppParametersResponse
 */
export class AppParametersResponse extends Message {
    /**
     * @generated from field: penumbra.core.app.v1.AppParameters parameters = 1;
     */
    parameters;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.AppParametersResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "parameters", kind: "message", T: AppParameters },
    ]);
    static fromBinary(bytes, options) {
        return new AppParametersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AppParametersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AppParametersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AppParametersResponse, a, b);
    }
}
/**
 * Requests the current gas prices from the view service.
 *
 * @generated from message penumbra.view.v1.GasPricesRequest
 */
export class GasPricesRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.GasPricesRequest";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new GasPricesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GasPricesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GasPricesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GasPricesRequest, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.GasPricesResponse
 */
export class GasPricesResponse extends Message {
    /**
     * The current gas prices, in the preferred (native) token.
     *
     * @generated from field: penumbra.core.component.fee.v1.GasPrices gas_prices = 1;
     */
    gasPrices;
    /**
     * Other gas prices for other accepted tokens.
     *
     * @generated from field: repeated penumbra.core.component.fee.v1.GasPrices alt_gas_prices = 2;
     */
    altGasPrices = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.GasPricesResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "gas_prices", kind: "message", T: GasPrices },
        { no: 2, name: "alt_gas_prices", kind: "message", T: GasPrices, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new GasPricesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GasPricesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GasPricesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GasPricesResponse, a, b);
    }
}
/**
 * Requests the current FMD parameters from the view service.
 *
 * @generated from message penumbra.view.v1.FMDParametersRequest
 */
export class FMDParametersRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.FMDParametersRequest";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new FMDParametersRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FMDParametersRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FMDParametersRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FMDParametersRequest, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.FMDParametersResponse
 */
export class FMDParametersResponse extends Message {
    /**
     * @generated from field: penumbra.core.component.shielded_pool.v1.FmdParameters parameters = 1;
     */
    parameters;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.FMDParametersResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "parameters", kind: "message", T: FmdParameters },
    ]);
    static fromBinary(bytes, options) {
        return new FMDParametersResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FMDParametersResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FMDParametersResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FMDParametersResponse, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.NoteByCommitmentRequest
 */
export class NoteByCommitmentRequest extends Message {
    /**
     * @generated from field: penumbra.crypto.tct.v1.StateCommitment note_commitment = 2;
     */
    noteCommitment;
    /**
     * If set to true, waits to return until the requested note is detected.
     *
     * @generated from field: bool await_detection = 3;
     */
    awaitDetection = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.NoteByCommitmentRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "note_commitment", kind: "message", T: StateCommitment },
        { no: 3, name: "await_detection", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new NoteByCommitmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NoteByCommitmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NoteByCommitmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NoteByCommitmentRequest, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.NoteByCommitmentResponse
 */
export class NoteByCommitmentResponse extends Message {
    /**
     * @generated from field: penumbra.view.v1.SpendableNoteRecord spendable_note = 1;
     */
    spendableNote;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.NoteByCommitmentResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "spendable_note", kind: "message", T: SpendableNoteRecord },
    ]);
    static fromBinary(bytes, options) {
        return new NoteByCommitmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NoteByCommitmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NoteByCommitmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NoteByCommitmentResponse, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.SwapByCommitmentRequest
 */
export class SwapByCommitmentRequest extends Message {
    /**
     * @generated from field: penumbra.crypto.tct.v1.StateCommitment swap_commitment = 2;
     */
    swapCommitment;
    /**
     * If set to true, waits to return until the requested swap is detected.
     *
     * @generated from field: bool await_detection = 3;
     */
    awaitDetection = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.SwapByCommitmentRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "swap_commitment", kind: "message", T: StateCommitment },
        { no: 3, name: "await_detection", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new SwapByCommitmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SwapByCommitmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SwapByCommitmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SwapByCommitmentRequest, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.SwapByCommitmentResponse
 */
export class SwapByCommitmentResponse extends Message {
    /**
     * @generated from field: penumbra.view.v1.SwapRecord swap = 1;
     */
    swap;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.SwapByCommitmentResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "swap", kind: "message", T: SwapRecord },
    ]);
    static fromBinary(bytes, options) {
        return new SwapByCommitmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SwapByCommitmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SwapByCommitmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SwapByCommitmentResponse, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.UnclaimedSwapsRequest
 */
export class UnclaimedSwapsRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.UnclaimedSwapsRequest";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new UnclaimedSwapsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnclaimedSwapsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnclaimedSwapsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnclaimedSwapsRequest, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.UnclaimedSwapsResponse
 */
export class UnclaimedSwapsResponse extends Message {
    /**
     * @generated from field: penumbra.view.v1.SwapRecord swap = 1;
     */
    swap;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.UnclaimedSwapsResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "swap", kind: "message", T: SwapRecord },
    ]);
    static fromBinary(bytes, options) {
        return new UnclaimedSwapsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnclaimedSwapsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnclaimedSwapsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnclaimedSwapsResponse, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.NullifierStatusRequest
 */
export class NullifierStatusRequest extends Message {
    /**
     * @generated from field: penumbra.core.component.sct.v1.Nullifier nullifier = 2;
     */
    nullifier;
    /**
     * @generated from field: bool await_detection = 3;
     */
    awaitDetection = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.NullifierStatusRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "nullifier", kind: "message", T: Nullifier },
        { no: 3, name: "await_detection", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new NullifierStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NullifierStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NullifierStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NullifierStatusRequest, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.NullifierStatusResponse
 */
export class NullifierStatusResponse extends Message {
    /**
     * @generated from field: bool spent = 1;
     */
    spent = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.NullifierStatusResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "spent", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new NullifierStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NullifierStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NullifierStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NullifierStatusResponse, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.TransactionInfoByHashRequest
 */
export class TransactionInfoByHashRequest extends Message {
    /**
     * The transaction hash to query for.
     *
     * @generated from field: penumbra.core.txhash.v1.TransactionId id = 2;
     */
    id;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.TransactionInfoByHashRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "id", kind: "message", T: TransactionId },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionInfoByHashRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionInfoByHashRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionInfoByHashRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionInfoByHashRequest, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.TransactionInfoRequest
 */
export class TransactionInfoRequest extends Message {
    /**
     * If present, return only transactions after this height.
     *
     * @generated from field: uint64 start_height = 1;
     */
    startHeight = protoInt64.zero;
    /**
     * If present, return only transactions before this height.
     *
     * @generated from field: uint64 end_height = 2;
     */
    endHeight = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.TransactionInfoRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "start_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 2, name: "end_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionInfoRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionInfoRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionInfoRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionInfoRequest, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.TransactionInfo
 */
export class TransactionInfo extends Message {
    /**
     * The height the transaction was included in a block, if known.
     *
     * @generated from field: uint64 height = 1;
     */
    height = protoInt64.zero;
    /**
     * The hash of the transaction.
     *
     * @generated from field: penumbra.core.txhash.v1.TransactionId id = 2;
     */
    id;
    /**
     * The transaction data itself.
     *
     * @generated from field: penumbra.core.transaction.v1.Transaction transaction = 3;
     */
    transaction;
    /**
     * The transaction perspective, as seen by this view server.
     *
     * @generated from field: penumbra.core.transaction.v1.TransactionPerspective perspective = 4;
     */
    perspective;
    /**
     * A precomputed transaction view of `transaction` from `perspective`, included for convenience of clients that don't have support for viewing transactions on their own.
     *
     * @generated from field: penumbra.core.transaction.v1.TransactionView view = 5;
     */
    view;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.TransactionInfo";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 2, name: "id", kind: "message", T: TransactionId },
        { no: 3, name: "transaction", kind: "message", T: Transaction },
        { no: 4, name: "perspective", kind: "message", T: TransactionPerspective },
        { no: 5, name: "view", kind: "message", T: TransactionView },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionInfo, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.TransactionInfoResponse
 */
export class TransactionInfoResponse extends Message {
    /**
     * @generated from field: penumbra.view.v1.TransactionInfo tx_info = 1;
     */
    txInfo;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.TransactionInfoResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "tx_info", kind: "message", T: TransactionInfo },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionInfoResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionInfoResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionInfoResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionInfoResponse, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.TransactionInfoByHashResponse
 */
export class TransactionInfoByHashResponse extends Message {
    /**
     * @generated from field: penumbra.view.v1.TransactionInfo tx_info = 1;
     */
    txInfo;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.TransactionInfoByHashResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "tx_info", kind: "message", T: TransactionInfo },
    ]);
    static fromBinary(bytes, options) {
        return new TransactionInfoByHashResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransactionInfoByHashResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransactionInfoByHashResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransactionInfoByHashResponse, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.NotesResponse
 */
export class NotesResponse extends Message {
    /**
     * @generated from field: penumbra.view.v1.SpendableNoteRecord note_record = 1;
     */
    noteRecord;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.NotesResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "note_record", kind: "message", T: SpendableNoteRecord },
    ]);
    static fromBinary(bytes, options) {
        return new NotesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NotesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NotesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NotesResponse, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.NotesForVotingResponse
 */
export class NotesForVotingResponse extends Message {
    /**
     * @generated from field: penumbra.view.v1.SpendableNoteRecord note_record = 1;
     */
    noteRecord;
    /**
     * @generated from field: penumbra.core.keys.v1.IdentityKey identity_key = 2;
     */
    identityKey;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.NotesForVotingResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "note_record", kind: "message", T: SpendableNoteRecord },
        { no: 2, name: "identity_key", kind: "message", T: IdentityKey },
    ]);
    static fromBinary(bytes, options) {
        return new NotesForVotingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NotesForVotingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NotesForVotingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NotesForVotingResponse, a, b);
    }
}
/**
 * A note plaintext with associated metadata about its status.
 *
 * @generated from message penumbra.view.v1.SpendableNoteRecord
 */
export class SpendableNoteRecord extends Message {
    /**
     * The note commitment, identifying the note.
     *
     * @generated from field: penumbra.crypto.tct.v1.StateCommitment note_commitment = 1;
     */
    noteCommitment;
    /**
     * The note plaintext itself.
     *
     * @generated from field: penumbra.core.component.shielded_pool.v1.Note note = 2;
     */
    note;
    /**
     * A precomputed decryption of the note's address incore.component.dex.v1.
     *
     * @generated from field: penumbra.core.keys.v1.AddressIndex address_index = 3;
     */
    addressIndex;
    /**
     * The note's nullifier.
     *
     * @generated from field: penumbra.core.component.sct.v1.Nullifier nullifier = 4;
     */
    nullifier;
    /**
     * The height at which the note was created.
     *
     * @generated from field: uint64 height_created = 5;
     */
    heightCreated = protoInt64.zero;
    /**
     * Records whether the note was spent (and if so, at what height).
     *
     * @generated from field: uint64 height_spent = 6;
     */
    heightSpent = protoInt64.zero;
    /**
     * The note position.
     *
     * @generated from field: uint64 position = 7;
     */
    position = protoInt64.zero;
    /**
     * The source of the note
     *
     * @generated from field: penumbra.core.component.sct.v1.CommitmentSource source = 8;
     */
    source;
    /**
     * The sender's return address, if known.
     *
     * @generated from field: penumbra.core.keys.v1.AddressView return_address = 9;
     */
    returnAddress;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.SpendableNoteRecord";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "note_commitment", kind: "message", T: StateCommitment },
        { no: 2, name: "note", kind: "message", T: Note },
        { no: 3, name: "address_index", kind: "message", T: AddressIndex },
        { no: 4, name: "nullifier", kind: "message", T: Nullifier },
        { no: 5, name: "height_created", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 6, name: "height_spent", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 7, name: "position", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 8, name: "source", kind: "message", T: CommitmentSource },
        { no: 9, name: "return_address", kind: "message", T: AddressView },
    ]);
    static fromBinary(bytes, options) {
        return new SpendableNoteRecord().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SpendableNoteRecord().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SpendableNoteRecord().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SpendableNoteRecord, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.SwapRecord
 */
export class SwapRecord extends Message {
    /**
     * @generated from field: penumbra.crypto.tct.v1.StateCommitment swap_commitment = 1;
     */
    swapCommitment;
    /**
     * @generated from field: penumbra.core.component.dex.v1.SwapPlaintext swap = 2;
     */
    swap;
    /**
     * @generated from field: uint64 position = 3;
     */
    position = protoInt64.zero;
    /**
     * @generated from field: penumbra.core.component.sct.v1.Nullifier nullifier = 4;
     */
    nullifier;
    /**
     * @generated from field: penumbra.core.component.dex.v1.BatchSwapOutputData output_data = 5;
     */
    outputData;
    /**
     * @generated from field: uint64 height_claimed = 6;
     */
    heightClaimed = protoInt64.zero;
    /**
     * @generated from field: penumbra.core.component.sct.v1.CommitmentSource source = 7;
     */
    source;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.SwapRecord";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "swap_commitment", kind: "message", T: StateCommitment },
        { no: 2, name: "swap", kind: "message", T: SwapPlaintext },
        { no: 3, name: "position", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 4, name: "nullifier", kind: "message", T: Nullifier },
        { no: 5, name: "output_data", kind: "message", T: BatchSwapOutputData },
        { no: 6, name: "height_claimed", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 7, name: "source", kind: "message", T: CommitmentSource },
    ]);
    static fromBinary(bytes, options) {
        return new SwapRecord().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SwapRecord().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SwapRecord().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SwapRecord, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.OwnedPositionIdsRequest
 */
export class OwnedPositionIdsRequest extends Message {
    /**
     * If present, return only positions with this position state.
     *
     * @generated from field: penumbra.core.component.dex.v1.PositionState position_state = 1;
     */
    positionState;
    /**
     * If present, return only positions for this trading pair.
     *
     * @generated from field: penumbra.core.component.dex.v1.TradingPair trading_pair = 2;
     */
    tradingPair;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.OwnedPositionIdsRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "position_state", kind: "message", T: PositionState },
        { no: 2, name: "trading_pair", kind: "message", T: TradingPair },
    ]);
    static fromBinary(bytes, options) {
        return new OwnedPositionIdsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OwnedPositionIdsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OwnedPositionIdsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OwnedPositionIdsRequest, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.OwnedPositionIdsResponse
 */
export class OwnedPositionIdsResponse extends Message {
    /**
     * @generated from field: penumbra.core.component.dex.v1.PositionId position_id = 1;
     */
    positionId;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.OwnedPositionIdsResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "position_id", kind: "message", T: PositionId },
    ]);
    static fromBinary(bytes, options) {
        return new OwnedPositionIdsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OwnedPositionIdsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OwnedPositionIdsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OwnedPositionIdsResponse, a, b);
    }
}
/**
 * Requests information on an asset by asset id
 *
 * @generated from message penumbra.view.v1.AssetMetadataByIdRequest
 */
export class AssetMetadataByIdRequest extends Message {
    /**
     * The asset id to request information on.
     *
     * @generated from field: penumbra.core.asset.v1.AssetId asset_id = 2;
     */
    assetId;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.AssetMetadataByIdRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "asset_id", kind: "message", T: AssetId },
    ]);
    static fromBinary(bytes, options) {
        return new AssetMetadataByIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AssetMetadataByIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AssetMetadataByIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AssetMetadataByIdRequest, a, b);
    }
}
/**
 * @generated from message penumbra.view.v1.AssetMetadataByIdResponse
 */
export class AssetMetadataByIdResponse extends Message {
    /**
     * If present, information on the requested asset.
     *
     * If the requested asset was unknown, this field will not be present.
     *
     * @generated from field: penumbra.core.asset.v1.Metadata denom_metadata = 1;
     */
    denomMetadata;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.AssetMetadataByIdResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "denom_metadata", kind: "message", T: Metadata },
    ]);
    static fromBinary(bytes, options) {
        return new AssetMetadataByIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AssetMetadataByIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AssetMetadataByIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AssetMetadataByIdResponse, a, b);
    }
}
/**
 * Requests `ValueView`s of delegation tokens for the given address index. The
 * returned `ValueView`s will include the `ValidatorInfo` for the delegated
 * validator in their `extended_metadata` fields.
 *
 * @generated from message penumbra.view.v1.DelegationsByAddressIndexRequest
 */
export class DelegationsByAddressIndexRequest extends Message {
    /**
     * The address index to fetch delegation balances for.
     *
     * @generated from field: penumbra.core.keys.v1.AddressIndex address_index = 1;
     */
    addressIndex;
    /**
     * @generated from field: penumbra.view.v1.DelegationsByAddressIndexRequest.Filter filter = 2;
     */
    filter = DelegationsByAddressIndexRequest_Filter.UNSPECIFIED;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.DelegationsByAddressIndexRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "address_index", kind: "message", T: AddressIndex },
        { no: 2, name: "filter", kind: "enum", T: proto3.getEnumType(DelegationsByAddressIndexRequest_Filter) },
    ]);
    static fromBinary(bytes, options) {
        return new DelegationsByAddressIndexRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DelegationsByAddressIndexRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DelegationsByAddressIndexRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DelegationsByAddressIndexRequest, a, b);
    }
}
/**
 * @generated from enum penumbra.view.v1.DelegationsByAddressIndexRequest.Filter
 */
export var DelegationsByAddressIndexRequest_Filter;
(function (DelegationsByAddressIndexRequest_Filter) {
    /**
     * By default, returns delegations for all active validators. For validators
     * that the given address index has no delegation tokens for, a `ValueView`
     * with a balance of `0` will be returned.
     *
     * @generated from enum value: FILTER_UNSPECIFIED = 0;
     */
    DelegationsByAddressIndexRequest_Filter[DelegationsByAddressIndexRequest_Filter["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * Returns only delegations to active validators that the given address
     * index holds delegation tokens for.
     *
     * @generated from enum value: FILTER_ALL_ACTIVE_WITH_NONZERO_BALANCES = 1;
     */
    DelegationsByAddressIndexRequest_Filter[DelegationsByAddressIndexRequest_Filter["ALL_ACTIVE_WITH_NONZERO_BALANCES"] = 1] = "ALL_ACTIVE_WITH_NONZERO_BALANCES";
    /**
     * Return delegations for all validators, whether active or not. For
     * validators that the given address index has no delegation tokens for, a
     * `ValueView` with a balance of `0` will be returned.
     *
     * @generated from enum value: FILTER_ALL = 2;
     */
    DelegationsByAddressIndexRequest_Filter[DelegationsByAddressIndexRequest_Filter["ALL"] = 2] = "ALL";
})(DelegationsByAddressIndexRequest_Filter || (DelegationsByAddressIndexRequest_Filter = {}));
// Retrieve enum metadata with: proto3.getEnumType(DelegationsByAddressIndexRequest_Filter)
proto3.util.setEnumType(DelegationsByAddressIndexRequest_Filter, "penumbra.view.v1.DelegationsByAddressIndexRequest.Filter", [
    { no: 0, name: "FILTER_UNSPECIFIED" },
    { no: 1, name: "FILTER_ALL_ACTIVE_WITH_NONZERO_BALANCES" },
    { no: 2, name: "FILTER_ALL" },
]);
/**
 * Contains a `ValueView` of delegation tokens for the requested address index.
 * The `ValueView` includes the `ValidatorInfo` for the delegated validator in
 * cits `extended_metadata` field.
 *
 * @generated from message penumbra.view.v1.DelegationsByAddressIndexResponse
 */
export class DelegationsByAddressIndexResponse extends Message {
    /**
     * @generated from field: penumbra.core.asset.v1.ValueView value_view = 1;
     */
    valueView;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.DelegationsByAddressIndexResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "value_view", kind: "message", T: ValueView },
    ]);
    static fromBinary(bytes, options) {
        return new DelegationsByAddressIndexResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DelegationsByAddressIndexResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DelegationsByAddressIndexResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DelegationsByAddressIndexResponse, a, b);
    }
}
/**
 * Requests unbonding tokens for a given address index, with optional filtering
 * for whether the tokens are currently claimable.
 *
 * @generated from message penumbra.view.v1.UnbondingTokensByAddressIndexRequest
 */
export class UnbondingTokensByAddressIndexRequest extends Message {
    /**
     * @generated from field: penumbra.view.v1.UnbondingTokensByAddressIndexRequest.Filter filter = 1;
     */
    filter = UnbondingTokensByAddressIndexRequest_Filter.UNSPECIFIED;
    /**
     * The address index to fetch unbonding tokens for.
     *
     * @generated from field: penumbra.core.keys.v1.AddressIndex address_index = 2;
     */
    addressIndex;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.UnbondingTokensByAddressIndexRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "filter", kind: "enum", T: proto3.getEnumType(UnbondingTokensByAddressIndexRequest_Filter) },
        { no: 2, name: "address_index", kind: "message", T: AddressIndex },
    ]);
    static fromBinary(bytes, options) {
        return new UnbondingTokensByAddressIndexRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnbondingTokensByAddressIndexRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnbondingTokensByAddressIndexRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnbondingTokensByAddressIndexRequest, a, b);
    }
}
/**
 * @generated from enum penumbra.view.v1.UnbondingTokensByAddressIndexRequest.Filter
 */
export var UnbondingTokensByAddressIndexRequest_Filter;
(function (UnbondingTokensByAddressIndexRequest_Filter) {
    /**
     * Return all unbonding tokens, regardless of whether they're claimable
     * right now.
     *
     * @generated from enum value: FILTER_UNSPECIFIED = 0;
     */
    UnbondingTokensByAddressIndexRequest_Filter[UnbondingTokensByAddressIndexRequest_Filter["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * Return all unbonding tokens that are currently claimable. This includes:
     * - tokens that have passed the `unbonding_delay` (from `StakeParameters`)
     * - tokens for unbonded validators
     *
     * @generated from enum value: FILTER_CLAIMABLE = 1;
     */
    UnbondingTokensByAddressIndexRequest_Filter[UnbondingTokensByAddressIndexRequest_Filter["CLAIMABLE"] = 1] = "CLAIMABLE";
    /**
     * Return all unbonding tokens that are not yet claimable, because they are
     * still in the `unbonding_delay` (from `StakeParameters`) period.
     *
     * @generated from enum value: FILTER_NOT_YET_CLAIMABLE = 2;
     */
    UnbondingTokensByAddressIndexRequest_Filter[UnbondingTokensByAddressIndexRequest_Filter["NOT_YET_CLAIMABLE"] = 2] = "NOT_YET_CLAIMABLE";
})(UnbondingTokensByAddressIndexRequest_Filter || (UnbondingTokensByAddressIndexRequest_Filter = {}));
// Retrieve enum metadata with: proto3.getEnumType(UnbondingTokensByAddressIndexRequest_Filter)
proto3.util.setEnumType(UnbondingTokensByAddressIndexRequest_Filter, "penumbra.view.v1.UnbondingTokensByAddressIndexRequest.Filter", [
    { no: 0, name: "FILTER_UNSPECIFIED" },
    { no: 1, name: "FILTER_CLAIMABLE" },
    { no: 2, name: "FILTER_NOT_YET_CLAIMABLE" },
]);
/**
 * Returns unbonding tokens for the given address index, optionally filtered by
 * whether the tokens are currently claimable.
 *
 * @generated from message penumbra.view.v1.UnbondingTokensByAddressIndexResponse
 */
export class UnbondingTokensByAddressIndexResponse extends Message {
    /**
     * A `ValueView` representing the amount of the given unbonding token.
     *
     * @generated from field: penumbra.core.asset.v1.ValueView value_view = 1;
     */
    valueView;
    /**
     * Whether the unbonding token is currently claimable. This will only be
     * `true` if the `unbonding_delay` (from `StakeParameters`) has passed or the
     * validator has unbonded.
     *
     * @generated from field: bool claimable = 2;
     */
    claimable = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.view.v1.UnbondingTokensByAddressIndexResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "value_view", kind: "message", T: ValueView },
        { no: 2, name: "claimable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new UnbondingTokensByAddressIndexResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnbondingTokensByAddressIndexResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnbondingTokensByAddressIndexResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnbondingTokensByAddressIndexResponse, a, b);
    }
}
